import BoardList from "@/components/BoardList";
import { RENDERCARDTYPE } from "@/constants/renderCardType";
import { getRelatedBoards } from "@/services";
import pvTracker from "@/tracker/report/pvTracker";
import getPageData from "@/tracker/shared/getPageData";
import useRequest from "@/utils/useReq";
import { useSetState } from "ahooks";
import { last } from "lodash";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
// 同在画板
function PinRelatedBoardList({
  pinId,
  isModal,
  onFirstLoad,
  initList,
  similiarList,
  showSimilarList,
  customColumn,
}) {
  const [query, setQuery] = useSetState({
    max: initList?.length ? last(initList).seq : 0,
    pinId: null,
  });
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState(initList || []);
  // const [ads, setAds] = useState([]);
  const [scrollableTarget, setScrollableTarget] = useState(null);

  // 服务端初始化标识
  const ssrInitRef = useRef(initList);
  useRequest(
    async () => {
      const { max, pinId } = query;

      if (!pinId) {
        return;
      }

      // 如果服务端有初始化渲染，不做第一次请求，避免多余请求
      if (ssrInitRef.current) {
        ssrInitRef.current = false;
        return;
      }

      const result = await getRelatedBoards({
        pin_id: pinId,
        limit: 20,
        ...(max ? { max } : null),
      });

      const boards = result?.boards || [];

      // 加载后回调，只有在第一次加载才会调用
      if (onFirstLoad && max === 0) {
        onFirstLoad(boards);
      }

      if (boards.length <= 0) {
        setHasMore(false);
      }

      setDataSource(dataSource.concat(boards));
    },
    {
      refreshDeps: [query],
    }
  );

  const onLoadMore = useCallback(() => {
    if (dataSource.length > 0) {
      const last = dataSource[dataSource.length - 1];
      setQuery({
        max: last.seq || last.board_id,
      });
      pvTracker(getPageData());
    }
  }, [dataSource, setQuery]);

  useEffect(() => {
    if (pinId) {
      setHasMore(true);
      setDataSource(initList || []);
      setQuery({
        max: initList?.length ? last(initList).seq : 0,
        pinId,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pinId, setQuery]);

  useEffect(() => {
    if (isModal) {
      setScrollableTarget(document.querySelector(".pinDetailModal"));
    }
  }, [isModal]);

  const list = useMemo(() => {
    if (dataSource.length <= 0 || !similiarList.data?.pins?.length) {
      return dataSource;
    }
    const list = [...dataSource];

    if (showSimilarList && similiarList.data?.pins?.length) {
      list.unshift({
        ...similiarList,
        type: RENDERCARDTYPE.similar,
        pinId,
        board_id: pinId,
      });
    }
    return list;
  }, [dataSource, similiarList, pinId, showSimilarList]);

  if (isModal && !scrollableTarget) {
    return null;
  }

  return (
    <BoardList
      dataSource={list}
      hasMore={hasMore}
      onLoadMore={onLoadMore}
      scrollableTarget={scrollableTarget}
      customColumn={customColumn}
    />
  );
}
export default memo(PinRelatedBoardList);
